import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToasterService } from '../../../services/ToasterService';
import { AuthService } from '../../../services/AuthService';
import { STATUS_SUCCESS } from '../../../utils/constants';
export default function UseNavigation() {
  const userLoginData = localStorage.getItem('userLoginData');
  const navigate = useNavigate();
  const [showConfirmModalLogout, setShowConfirmModalLogout] = useState<boolean>(false);
  const parsedUserLoginData = useRef<any>({});
  // const customerId = useRef<any>('');

  // useEffect(() => {
  //   if (userLoginData) {
  //     parsedUserLoginData.current = JSON.parse(userLoginData);
  //     customerId.current = parsedUserLoginData.current?.customer_id;

  //     console.log('customerId.current - customerId.current:', customerId.current);
  //   }
  // }, []);

  const [customerId, setCustomerId] = useState<string | null>(null);

  useEffect(() => {
    if (userLoginData) {
      const parsedData = JSON.parse(userLoginData);
      const id = parsedData?.customer_id || null;
      setCustomerId(id);
      // console.log('Loaded customerId:', id);
    }
  }, [userLoginData]);

  const showLogoutConfirmModal = async () => {
    if (customerId && customerId && customerId !== '') {
      setShowConfirmModalLogout(true);
    } else {
      ToasterService.Error('Your Not login Please Login!');
      navigate('/home');
    }
  };

  async function logout() {
    setShowConfirmModalLogout(false);
    const resp = await AuthService.Logout();
    // console.log('Logout Resp:', resp);
    if (resp && resp.message && resp.message.status === STATUS_SUCCESS) {
      localStorage.clear();
      ToasterService.Success('Logout successfully');
      navigate('/home');
      window.location.reload();
    } else {
      ToasterService.Error('Server Error!..');
    }
  }

  return {
    logout,
    showConfirmModalLogout,
    showLogoutConfirmModal,
    setShowConfirmModalLogout,
    customerId,
  };
}
